import { SignatureComponent } from './signature.component';

export const SIGNATURE_DECLARATIONS: any[] = [SignatureComponent];
